import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQuery} from '../base-query'

export enum ZoomEnvironment {
  Sandbox = 'sandbox',
  Production = 'production',
}

export interface ZoomConfigResponse {
  clientId: string
  clientSecretMasked: string
  hasClientSecret: boolean
  redirectUrl: string
  environment: ZoomEnvironment
}

export interface SaveZoomConfigRequest {
  clientId: string
  clientSecret?: string
  environment: ZoomEnvironment
}

export interface ReplaceZoomSecretRequest {
  clientSecret: string
}

export interface ZoomTestConnectionResponse {
  success: boolean
  message: string
}

export const zoomConfigApi = createApi({
  reducerPath: 'ZoomConfigApi',
  tagTypes: ['ZoomConfig'],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getZoomConfig: builder.query<ZoomConfigResponse | null, void>({
      query: () => ({
        url: '/api/zoom/config',
        method: 'GET',
      }),
      providesTags: ['ZoomConfig'],
    }),

    saveZoomConfig: builder.mutation<ZoomConfigResponse, SaveZoomConfigRequest>({
      query: (body) => ({
        url: '/api/zoom/config',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ZoomConfig'],
    }),

    replaceZoomSecret: builder.mutation<ZoomConfigResponse, ReplaceZoomSecretRequest>({
      query: (body) => ({
        url: '/api/zoom/config/replace-secret',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ZoomConfig'],
    }),

    testZoomConnection: builder.mutation<ZoomTestConnectionResponse, void>({
      query: () => ({
        url: '/api/zoom/config/test-connection',
        method: 'POST',
      }),
    }),

    getZoomAuthorizeUrl: builder.query<{authorizeUrl: string}, void>({
      query: () => ({
        url: '/api/zoom/oauth/authorize',
        method: 'GET',
      }),
    }),

    disconnectZoom: builder.mutation<{success: boolean; message: string}, void>({
      query: () => ({
        url: '/api/zoom/oauth/disconnect',
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useGetZoomConfigQuery,
  useSaveZoomConfigMutation,
  useReplaceZoomSecretMutation,
  useTestZoomConnectionMutation,
  useLazyGetZoomAuthorizeUrlQuery,
  useDisconnectZoomMutation,
} = zoomConfigApi
